module.exports = __webpack_public_path__ + "img/railway.9a310aad.svg";